module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/document-framework-14.vue");


//////////////////
// WEBPACK FOOTER
// ./en/faq/document-framework.md
// module id = 590
// module chunks = 445